/** セクション名の最大文字数。 */
export const SECTION_NAME_MAX_LENGTH = 255
